import { useNavigate } from "react-router-dom";
import PavementContextCustom from "../../components/PavementContext/PavementContextCustom";
import "../PageCommon.css";
import "./PavementContextCustom.css";
import { useEffect } from "react";

const PavementContextCustomPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
      if (!localStorage.getItem('token')) {
        navigate('/signin');
      }
  }, [navigate]);

    return (
      <div className="page__container">
        <div className="page__body">
          <PavementContextCustom />          
        </div>
      </div>
    );
  }
  
  export default PavementContextCustomPage;